import lottie from "lottie-web";
import { useEffect, useRef } from "react";


const TgSticker = ({ src, loop = true }) => {
    const containerRef = useRef(null);
    const animationRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) return

        animationRef.current = lottie.loadAnimation({
            container: containerRef.current,
            renderer: 'svg',
            loop: loop,
            autoplay: true,
            path: src,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet'
            }
        })

        return () => {
            if (animationRef.current) {
                animationRef.current.destroy();
            }
        };
    }, [src, loop])

    return <div ref={containerRef} />
}

export default TgSticker;